import React, { useState, useEffect, useRef } from 'react';
import styles from './Add_Cart.module.css';
import { billing_api } from '../../../Apiconfig';
import axios from 'axios';
import { showCustomAlert } from '../../../customAlert';

const Add_Cart = () => {
  const [orders, setOrders] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null); // Store the currently selected order
  const [updatedAmount, setUpdatedAmount] = useState('');
  const [updatedStatus, setUpdatedStatus] = useState('');
  const dropdownRef = useRef(null);
  const [selectedPaymentMethod,setSelectedPaymentMethod] = useState('')

  const fetchOrders = async () => {
    try {
      const response = await axios.post(
        `${billing_api}add_on_cart.php`,
        {},
        {
          withCredentials: true,
        }
      );
      const data = response.data;
      setOrders(data);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };
  // console.log(orders)
  const handleDropdownClick = () => {
    setShowDropdown(!showDropdown);
    if (!showDropdown) {
      fetchOrders();
    }
  };

  const handleOrderClick = (order) => {
    setShowDropdown(false);
    setSelectedOrder(order);
    setUpdatedAmount(order.due_amount); // Pre-fill the current due amount
    setUpdatedStatus(order.order_status); // Pre-fill the current status
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  const handleUpdateOrder = async () => {
    try {
      const response = await axios.post(
        `${billing_api}update_pending_orders.php`,
        {
          order_id: selectedOrder.id,
          pay_amount: updatedAmount,
          order_status: updatedStatus,
          customer_id: selectedOrder.customer_id,
          due_amount: selectedOrder.due_amount,
          payment_method: selectedPaymentMethod,
          paid_amount: selectedOrder.paid_amount,
        },
        {
          withCredentials: true,
        }
      );
      if (response.data.success) {
        showCustomAlert('Order updated successfully!');
        setSelectedOrder(null); // Close the card after updating
        fetchOrders(); // Refresh the orders list
      } else {
        showCustomAlert('Failed to update the order.');
      }
    } catch (error) {
      console.error("Error updating order:", error);
    }
  };

  useEffect(() => {
    if (showDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDropdown]);

  // Handle payment method selection
  const handlePaymentMethodSelect = (method) => {
    setSelectedPaymentMethod(method);
  };


  return (
    <>
      <div className={styles.cartcontainer}>
        <i
          className="fa-solid fa-cart-shopping"
          onClick={handleDropdownClick}
          style={{ cursor: 'pointer' }}
        ></i>
      </div>

      {showDropdown && (
        <ul ref={dropdownRef} className={styles.dropdownMenu}>
          {orders.length > 0 ? (
            orders.map((order) => (
              <li
                key={order.id}
                onClick={() => handleOrderClick(order)}
                style={{ cursor: 'pointer' }}
              >
                Order #{order.id} | total = {order.total_amount} | due = {order.due_amount} | {order.order_status}
              </li>
            ))
          ) : (
            <li>No pending orders</li>
          )}
        </ul>
      )}

      {selectedOrder && (
        <>
          <div className={styles.cardmodalOverlay} onClick={() => setSelectedOrder(null)}></div>
          <div className={styles.orderCard}>
            <h3>Order Details</h3>
            <p>Order ID: {selectedOrder.id}</p>
            <p>Totall bill Amount:{selectedOrder.total_amount} </p>
            <p>Due Amount:{selectedOrder.due_amount} </p>
            <input
              type="number"
              value={updatedAmount}
              onChange={(e) => setUpdatedAmount(e.target.value)}
            />
            <p>Status:</p>
            <div className={styles.paymentMethods}>
              <button
                onClick={() => handlePaymentMethodSelect('Cash')}
                className={`${styles.paymentButton} ${selectedPaymentMethod === 'Cash' ? styles.active : ''
                  }`}
              >
                {selectedPaymentMethod === 'Cash' && (
                  <i className="fa-solid fa-check" style={{ marginRight: '8px' }}></i>
                )}
                Cash
              </button>
              <button
                onClick={() => handlePaymentMethodSelect('UPI')}
                className={`${styles.paymentButton} ${selectedPaymentMethod === 'UPI' ? styles.active : ''
                  }`}
              >
                {selectedPaymentMethod === 'UPI' && (
                  <i className="fa-solid fa-check" style={{ marginRight: '8px' }}></i>
                )}
                UPI
              </button>
            </div>
            <select
              value={updatedStatus}
              onChange={(e) => setUpdatedStatus(e.target.value)}
            >
              <option value="Pending">Pending</option>
              <option value="Completed">Completed</option>
              <option value="Cancelled">Cancelled</option>
            </select>
            <button className={styles.ordercardbutton} onClick={handleUpdateOrder}>Submit</button>
            <button  className={styles.ordercardbutton} onClick={() => setSelectedOrder(null)}>Close</button>
          </div>
        </>
      )}
    </>
  );
};

export default Add_Cart;
